import { service } from '../../../../helpers/http'

export const ActionGetAgentSettings = ({ dispatch }, payload) => {

    return service({
        module: 'domainAgentSetting',
        action: 'getAgentSettings',
        payload: payload
    })
    
}

export const ActionPostAgentSetting = ({ dispatch }, payload) => {

    return service({
        module: 'domainAgentSetting',
        action: 'postAgentSetting',
        payload: payload
    })
    
}

export const ActionPutAgentSetting = ({ dispatch }, payload) => {

    return service({
        module: 'domainAgentSetting',
        action: 'putAgentSetting',
        payload: payload
    })
    
}

export const ActionDeleteAgentSetting = ({ dispatch }, payload) => {

    return service({
        module: 'domainAgentSetting',
        action: 'deleteAgentSetting',
        payload: payload
    })
    
}

export const ActionGetAgentTypes = ({ dispatch }, payload) => {

    return service({
        module: 'domainAgentSetting',
        action: 'getAgentTypes',
        payload: payload
    })
    
}